<template>
  <div class="admin-layout">
    <!-- Sidebar -->
    <SidebarAdmin />

    <!-- Contenu principal -->
    <section class="main-content">
      <header class="page-header">
        <h2>📦 Gestion des commandes</h2>
        <p class="subtitle">Suivez et gérez les commandes en temps réel</p>
      </header>

      <!-- Filtres -->
      <div class="filter-bar">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="🔍 Rechercher un client..."
          class="search-input"
        />
        <select v-model="selectedStatus" class="status-filter">
          <option value="">Tous les statuts</option>
          <option value="En attente">En attente</option>
          <option value="En préparation">En préparation</option>
          <option value="Expédiée">Expédiée</option>
          <option value="Livrée">Livrée</option>
        </select>
      </div>

      <!-- Tableau -->
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Client</th>
              <th>Date</th>
              <th>Total TTC</th>
              <th>Statut</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in filteredOrders" :key="order._id">
              <td>{{ order._id.slice(-6).toUpperCase() }}</td>
              <td>{{ order.user.prenom }} {{ order.user.nom }}</td>
              <td>{{ formatDate(order.createdAt) }}</td>
              <td>{{ order.total ? order.total.toFixed(2) + " MAD" : "—" }}</td>
              <td>
                <span :class="['status', order.status.toLowerCase().replace(' ', '-')]">
                  {{ order.status }}
                </span>
              </td>
              <td class="action-buttons">
                <!-- 
                <button class="btn-details" @click="goToDetails(order._id)"> -->
                   <button class="btn-details" @click="goToDetails(order._id)">
                  Voir détails
                </button>
                <select
                  v-model="order.status"
                  @change="updateStatus(order)"
                  class="status-select"
                >
                  <option value="En attente">En attente</option>
                  <option value="En préparation">En préparation</option>
                  <option value="Expédiée">Expédiée</option>
                  <option value="Livrée">Livrée</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import SidebarAdmin from "@/views/admin/SidebarAdmin.vue";

export default {
  name: "AdminOrders",
  components: { SidebarAdmin },
  data() {
    return {
      searchQuery: "",
      selectedStatus: "",
      //  Données fictives pour test visuel
      orders: [
        {
          _id: "CMD001",
          user: { prenom: "Ghizlane", nom: "Majid" },
          createdAt: "2025-11-25T09:00:00",
          total: 1899.99,
          status: "En attente",
        },
 
        {
          _id: "CMD003",
          user: { prenom: "Sara", nom: "Benzekri" },
          createdAt: "2025-11-23T10:10:00",
          total: 780,
          status: "Expédiée",
        },
        {
          _id: "CMD004",
          user: { prenom: "Imane", nom: "Hammou" },
          createdAt: "2025-11-20T14:45:00",
          total: 3200,
          status: "Livrée",
        },
        {
          _id: "CMD005",
          user: { prenom: "Omar", nom: "Essadik" },
          createdAt: "2025-11-19T11:25:00",
          total: 999.9,
          status: "En attente",
        },
      ],
    };
  },
  computed: {
    filteredOrders() {
      return this.orders.filter((order) => {
        const nameMatch = `${order.user.prenom} ${order.user.nom}`
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const statusMatch = this.selectedStatus
          ? order.status === this.selectedStatus
          : true;
        return nameMatch && statusMatch;
      });
    },
  },
  methods: {
    updateStatus(order) {
      alert(`Statut de la commande ${order._id} mis à jour en : ${order.status}`);
    },
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    goToDetails(orderId) {
      alert(`➡️ Redirection vers la page de détails pour ${orderId}`);
      this.$router.push(`/ordersDetails/${orderId}`);
    },
  },
};
</script>

<style scoped>
/* === LAYOUT === */
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f4f6f9;
  font-family: "Poppins", sans-serif;
  transition: background 0.3s ease, color 0.3s ease;
}

.main-content {
  flex: 1;
  padding: 40px;
  background: #ffffff;
  border-radius: 0 16px 16px 0;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.05);
  overflow-x: hidden;
  transition: background 0.3s ease, color 0.3s ease;
}

/* === HEADER === */
.page-header {
  margin-bottom: 25px;
}
.page-header h2 {
  font-size: 24px;
  color: #05305b;
  margin-bottom: 5px;
  transition: color 0.3s ease;
}
.subtitle {
  color: #666;
  font-size: 14px;
}

/* === BARRE FILTRE === */
.filter-bar {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}
.search-input,
.status-filter {
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.25s ease;
}
.search-input:focus,
.status-filter:focus {
  border-color: #00998b;
  box-shadow: 0 0 0 3px rgba(0, 153, 139, 0.15);
}

/* === TABLEAU === */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
  scrollbar-width: thin;
}
.table-wrapper::-webkit-scrollbar {
  height: 8px;
}
.table-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: background 0.3s ease;
}
th,
td {
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
  text-align: left;
  font-size: 14px;
  white-space: nowrap;
  transition: color 0.3s ease, background 0.3s ease;
}
th {
  background-color: #f8f9fa;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 600;
}

/* === STATUTS === */
.status {
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 600;
  color: #fff;
  font-size: 13px;
  display: inline-block;
  text-transform: capitalize;
  transition: background 0.3s ease;
}
.status.en-attente {
  background: #ff9800;
}
.status.en-préparation {
  background: #2196f3;
}
.status.expédiée {
  background: #6f42c1;
}
.status.livrée {
  background: #4caf50;
}

/* === BOUTONS ACTION === */
.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.btn-details {
  background-color: #00998b;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-details:hover {
  background-color: #007f75;
  transform: translateY(-1px);
}
.status-select {
  padding: 5px 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 13px;
  outline: none;
  transition: border-color 0.3s ease;
}
.status-select:focus {
  border-color: #00998b;
}

/* === RESPONSIVE === */

/* TABLETTE */
@media (max-width: 700px) {
  .admin-layout {
    flex-direction: column;
  }
  .main-content {
    padding: 25px;
    border-radius: 0;
  }
  table {
    min-width: 700px;
  }
  th,
  td {
    padding: 12px 10px;
    font-size: 13px;
  }
  .filter-bar {
    flex-direction: row;
    justify-content: space-between;
  }
}

/* MOBILE */
@media (max-width: 600px) {
  .filter-bar {
    flex-direction: column;
  }
  table {
    min-width: 600px;
  }
  th,
  td {
    padding: 10px 8px;
    font-size: 12px;
  }
  .action-buttons {
    flex-direction: column;
    align-items: flex-start;
  }
  .btn-details {
    width: 100%;
    text-align: center;
  }
  .status-select {
    width: 100%;
  }
}

/* === MODE SOMBRE === */
@media (prefers-color-scheme: dark) {
  .admin-layout {
    background: #0f1720;
  }
  .main-content {
    background: #1a2532;
    color: #e6edf1;
  }
  .page-header h2 {
    color: #00c8b3;
  }
  .subtitle {
    color: #b0bec5;
  }
  table {
    background: #1f2b3a;
  }
  th {
    background: #253444;
    color: #e6edf1;
  }
  td {
    border-bottom: 1px solid #2e3d4d;
    color: #e1e8ed;
  }
  .search-input,
  .status-filter,
  .status-select {
    background: #24313f;
    color: #e6edf1;
    border-color: #3a4a5b;
  }
  .search-input:focus,
  .status-filter:focus,
  .status-select:focus {
    border-color: #00bfa5;
    box-shadow: 0 0 0 2px rgba(0, 191, 165, 0.3);
  }
  .btn-details {
    background-color: #00bfa5;
  }
  .btn-details:hover {
    background-color: #00a38c;
  }
  .status.en-attente {
    background: #ffb74d;
  }
  .status.en-préparation {
    background: #42a5f5;
  }
  .status.expédiée {
    background: #9575cd;
  }
  .status.livrée {
    background: #81c784;
  }
}
</style>

